import { decodeBase64ToUtf8 } from '@apia/util';
import { TComponentRender } from '../types';
import { MessageBlock } from './MessageBlock';
import { MDRenderer } from '@apia/components';
import { Box } from '@apia/theme';
import { TDescriberBlock } from '../StreamMessage';
import { observer } from 'mobx-react-lite';

export type TBlockType = 'text' | 'describer';

export type TBaseStreamBlock<T extends TBlockType = TBlockType> = {
  blockType: T;
};

export type TTextStreamBlock = TBaseStreamBlock<'text'> & { str: string };
export type TDescriberStreamBlock = TBaseStreamBlock<'describer'> & {
  describer: TDescriberBlock;
};

export type TStreamBlock = TTextStreamBlock | TDescriberStreamBlock;

export const MessageBlocks = observer(
  ({ streamParts }: { streamParts: TStreamBlock[] }) => {
    // str viene del server en el formato indicado
    const parts = streamParts.map((p, i) => {
      if (p.blockType === 'describer') {
        return (
          <Box
            variant="layout.common.ai.semanticSearch.execution.streamBlocks"
            className="sem_search__stream_blocks"
            as="ul"
            key={i}
          >
            {
              <Box
                variant="layout.common.ai.semanticSearch.execution.streamBlocks"
                as="li"
                className={`sem_search__stream_block ${p.describer.type}`}
              >
                {p.describer.content}
              </Box>
            }
          </Box>
        );
      } else if (p.blockType === 'text') {
        return p.str.split(/(!!\[[^]+])/g).map((c, j) => {
          // Se permiten las keys con indice porque esta lista no va a cambiar
          if (c.match(/^!!\[[^]+]$/)) {
            const definition = JSON.parse(
              decodeBase64ToUtf8(
                (c.match(/^!!\[([^]+)]$/) ?? [undefined, undefined])[1] ?? '',
              ),
            ) as TComponentRender;

            return (
              <MessageBlock
                key={`${i}-${j}`}
                componentData={definition}
              ></MessageBlock>
            );
          } else {
            return <MDRenderer str={c} key={`${i}-${j}`}></MDRenderer>;
          }
        });
      }
    });
    return parts;
  },
);
